import React from "react";
import styled from "styled-components";
import PropTypes from "prop-types";
import { Row, Col, Button, Table, notification } from "antd";
import { useQuery } from "@apollo/client";
import { useTranslation } from "react-i18next";
import {
  NumberParam,
  useQueryParam,
  withDefault,
} from "use-query-params";

import { LIMIT_PAGE } from "constants/index";

import { TERMINAL_COLUMNS } from "./constants";
import { TERMINALS_QUERY } from "./terminalQueries";

const Container = styled.div`
  margin: 12px;
`;

const StyledRow = styled(Row)`
  padding-bottom: 12px;
`;

const FlexCol = styled(Col)`
  display: flex;
  justify-content: flex-end;
`;

const Terminals = ({ history }) => {
  const { t } = useTranslation();
  const [page, setPage] = useQueryParam("page", withDefault(NumberParam, 1));
  const { loading, data } = useQuery(TERMINALS_QUERY, {
    onError: notification.error,
  });

  return (
    <Container>
      <StyledRow>
        <FlexCol>
          <Button
            type="primary"
            onClick={() => history.push("/access/terminals/new")}
          >
            {t("Add")}
          </Button>
        </FlexCol>
      </StyledRow>
      <Table
        rowKey="id"
        pagination={{
          current: page,
          onChange: setPage,
          pageSize: LIMIT_PAGE,
        }}
        columns={TERMINAL_COLUMNS}
        loading={loading}
        dataSource={data && data.terminals}
      />
    </Container>
  );
};

Terminals.propTypes = {
  history: PropTypes.object.isRequired,
};

export default Terminals;
